<template>
  <div :class="componentClassName">
    <slot>
      <div v-for="(item, index) in data" :key="index" class="m-data-list-holiday__row">
        <div class="m-data-list-holiday__col">{{ item.label }}</div>
        <div class="m-data-list-holiday__col">{{ item.type }}</div>
        <div class="m-data-list-holiday__col">{{ item.value }}</div>
      </div>
    </slot>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'm-data-list-holiday',
  props: {
    class: {
      type: String,
      default: '',
    },
    verticalAlign: {
      type: String,
      default: 'middle',
      validator(value) {
        return value.match(/(top|middle|bottom)/);
      },
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: null,
    },
    variant: {
      type: String,
      default: null,
      validation(value) {
        return value.match(/(long)/) || value === null;
      },
    },
    id: {
      type: String,
      default: '',
    },
  },
  emits: ['click:action'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-data-list-holiday', this.variant, this.alignRight ? 'align-right' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleActionClick(index) {
      this.$emit('click:action', index);
    },
  },
};
</script>
